import { render } from "./TwPaginationComponent.vue?vue&type=template&id=37146227"
import script from "./TwPaginationComponent.vue?vue&type=script&lang=js"
export * from "./TwPaginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__